<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <ApplicationFilter
            @onFilter="onFilter"
          />
          <!-- Table -->
          <div class="table-responsive mb-0">
            <b-table
              :busy="isBusy"
              :items="items"
              :fields="fields"
              responsive="lg"
              :per-page="perPage"
              :current-page="currentPage"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
              :show-empty="true"
              @sort-changed="sortChanged"
            >
            
            <!-- for status stepper -->
            <template #row-details="row">
              <div class="row">
                <div class="col-md-10" style="overflow-y: auto;">
                  <statusProgress :applicant="row.item" />
                </div>

                <div class="col-md-2 media">
                  <div class="media-body">
                    <div>
                      <span class="font-weight-bold">Assign to</span> : {{ row.item.assign_to && typeof row.item.assign_to == 'object' ? `${row.item.assign_to.first_name} ${row.item.assign_to.last_name}` : '-' }}
                    </div>
                    <div>
                      <span class="font-weight-bold">Substatus</span> : {{ row.item.sub_status || '-' }}
                    </div>
                  </div>
                </div>
              </div>
            </template>

             <!-- <template v-slot:cell(status)="row">
                <applicantProgress 
                  :status="row.item.status"
                  :applicant="row.item"
                  status-only
                />
              </template> -->

              <template v-slot:cell(actions)="row">
                  <button
                    type="button"
                    class="btn2 btn2-primary btn-sm mx-1 mb-1"
                    @click="openFormBar(row.item)"
                    v-if="role_modules.some(item => item.value == 'application.view')"
                  ><i class="uil uil-eye"></i>
                  </button>
              </template>

              <template v-slot:cell(full_name)="row">
                <div>
                  <a
                    href="#"
                    class="h6"
                    @click.prevent="openFormBar(row.item)"
                  > {{ row.item.candidate_id ? row.item.candidate_id.full_name : row.item.prospect ? row.item.prospect.full_name : '' }}
                  </a>
                  <span class="font-weight-bold small" v-if="row.item.reference_no">#{{row.item.reference_no}}</span>
                </div>
                <div class="text-muted">
                  {{row.item.candidate_id ? row.item.candidate_id.email : row.item.prospect ? row.item.prospect.email : ''}}
                </div>
              </template>

              <template v-slot:cell(application)="row">
                
                 <div class="media">
                  <div class="media-body">
                    <div>Company: {{row.item.job_id ? row.item.job_id.company_id.name : ''}}</div>
                    <div>Submitted by: {{ row.item.user && row.item.user.company ? row.item.user.company_name + ' - ' + row.item.user.full_name : row.item.user.parent_id != undefined ? (row.item.user.parent_id && row.item.user.parent_id.company ? row.item.user.parent_id.company_name + ' - ' + row.item.user.full_name : 'Individual - ' + row.item.user.first_name + ' ' + row.item.user.last_name) : 'Individual - ' + row.item.user.first_name + ' ' + row.item.user.last_name }}</div>
                    <div class="font-weight-bold text-primary">Job Title: {{row.item.job_id ? row.item.job_id.title : ''}}</div>
                  </div>
                </div>
              </template>

              <template v-slot:cell(status)="row">
                <div class="row justify-content-between">
                  <button
                    class="custom-chip"
                    :class="`chip-status${row.item.rejected ? '8' : row.item.status_type}`"
                    @click="changeStatus(row.item._id, row.item.add_interview_step)"
                  >
                    {{ applicationStatusLabel(row.item.status) }}
                  </button>
                  <img 
                    v-if="user.access_type !== 'candidate'"
                    src="https://cdn-icons-png.flaticon.com/128/10146/10146590.png" 
                    style="width:20px; height:20px; cursor: pointer;" 
                    class="my-auto mr-auto ml-2"
                    @click="changeStatus(row.item._id, row.item.add_interview_step)"
                  />
                  <a
                    href="#"
                    @click.prevent="row.toggleDetails"
                  > <i :class="`uil uil-angle-${row.detailsShowing ? 'up' : 'down'} ml-1 h3`" />
                  </a>
                </div>
              </template>

              <template v-slot:table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>

            </b-table>
          </div>
          <div class="d-flex mb-md-2 justify-content-end">
            <div class="">
              <div class="dataTables_length">
                <label class="d-inline-flex align-items-center dataTable_entries">
                  <span >{{$t('common.show')}}</span>
                  <b-form-select
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                  <span >{{$t('common.entries')}}</span>
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      <Dialog
        centered
        ref="side_bar"
        title="View Application"
        size="xl"
        bodyClass="modalBodyContainer px-4"
        :parameters="{ applicationID: id, candidateID: candidate_id }"
        :component="viewComponent"
      />
      <Dialog
        centered
        ref="status"
        title="Change Status"
        size="lg"
        yesText="Save"
        noText="Cancel"
        @onYes="updateStatus"
        bodyClass="modalBodyContainer px-4"
        :parameters="{ applicationID: id }"
        :component="editStatusComponent"
      />
  </div>
</template>

<script>
  /* import { tableData } from './data-advance' */
  import { mapActions } from 'vuex'
  import moment from 'moment/moment'
  import FormMixin from '@mixins/form'
  import Dialog from '@components/offcanvas'
  // import applicantProgress from '@components/applicantProgress'
  import statusProgress from './components/dialogs/statusProgress.vue'
  import Dropdown from '@src/static/dropdown'
  import ApplicationFilter from '@common/list/applicationFilter.vue'
  // import SideBar from './viewModal'
  import { mapState } from 'vuex'

  export default {
    components:{
      // applicantProgress,
      Dialog,
      statusProgress,
      // SideBar,
      ApplicationFilter
    },
    mixins: [FormMixin],
    props:{
      initialLoad:{
        default:true
      },
      initialType: String,
    },
    data() {
      return {
        title: this.$t('application.plural'),
        items: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 20,
        pageOptions: [20, 50, 100, 200],
        filter: null,
        filterOn: [],
        searchText: '',
        sortBy: '',
        sortDesc: false,
        fields: 
        [
          
          {
            key: 'full_name',
            label:this.$t('application.table.candidate'),
            tdClass: 'align-middle',
          },
          {
            key: 'application',
            label:this.$t('application.table.applicant_details'),
            tdClass: 'align-middle',
          },
          {
            key: 'status',
            label: this.$t('application.table.status'), 
            sortable: true,
            align: "center",
            tdClass: 'align-middle',
          },
          {
            key:'date_applied',
            label:this.$t('application.table.date_applied'),
            formatter: (value) => {
              return moment(value).format('YYYY-MM-DD')
            },
            sortable: true,
            tdClass: 'align-middle',
          },
          {
            key:'actions',
            label:'',
            tdClass: 'align-middle',
          }
        ],
        isBusy:false,
        type:'all',
        id: '',
        candidate_id: '',
        isSidebarOpen: false,
        statusOptions: [
          {value: 1, text: 'Shortlisted', active: false, total: 0}, 
          {value: 2, text: 'Submitted', active: false, total: 0}, 
          {value: 3, text: '1st Interview', active: false, total: 0}, 
          {value: 4, text: '2nd Interview', active: false, total: 0}, 
          {value: 5, text: 'Additional Interview', active: false, total: 0}, 
          {value: 6, text: 'Offered', active: false, total: 0}, 
          {value: 7, text: 'Placed', active: false, total: 0},
          {value: 8, text: 'Rejected', active: false, total: 0}, 
        ],
        statusParams: [],
        add_interview_step: '',
        filterItems: {}
      }
    },
    computed: {
      rows() {
        return this.totalRows
      },
      viewComponent() {
        return () => import('./components/dialogs/view.vue')
      },
      editStatusComponent() {
        return () => import('./components/dialogs/editStatus.vue')
      },
      ...mapState('auth', ['user'])
    },
    mounted() {
      if(this.initialLoad){
        this.type = this.initialType || this.type
        this.fetchData(this.type)
      }
    },
    methods: {
      ...mapActions('application', ['pagination', 'approve', 'update']),
      ...mapActions('company', ['getVincereApplication']),
      toggleApprove(uiid, approve){
        this.$bvModal.msgBoxConfirm('Are you sure you want to '+(approve ? 'Approve' : 'Reject')+' application?', {
          title: 'Please Confirm Action',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(res => {
          if(res == true){
            this.toggleLoading()

            this.approve({
              id:uiid,
              approve:approve
            }).then((res) => {
              this.fetchData(this.type)
              this.$bvToast.toast('Successfully '+(res.data.approve ? 'Approved' : 'Rejected')+'!', {
                title: 'Notification',
                variant: res.data.approve? 'success':'danger'
              })
              this.toggleLoading()
            })
          }
        })
      },
      syncDatas(){
        this.toggleBusy()
        this.getVincereApplication(this.model).then(res => {
          if(res.data.status){
            this.fetchData(this.type, true)
          }
        }).catch(err => {
          console.log(err);
        })
      },
      sortChanged(e){
        this.sortBy = e.sortBy
        this.sortDesc = e.sortDesc
      },
      applicationStatusLabel(status) {
        if (status == null || status === '') return '-'
        const s = String(status)
        const key = `application.status_value.${s}`
        return this.$te(key) ? this.$t(key) : s
      },
      filterList(){
        this.fetchData(this.type)
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      async fetchData(type, reload = false, paramStatus = undefined, paramRejected = undefined) {
        if(this.role_modules.some(item => item.value == 'application')){
          if(!reload){
            this.toggleBusy()
          }

          let items = this.filterItems

          await this.pagination({
            limit:this.perPage,
            start:this.currentPage,
            type:type,
            filter: this.filter || items.filter,
            status: paramStatus || items.status,
            rejected: paramRejected,
            sub_status: items.substatus,
            assign_to: items.assignTo
          })
          .then(res => {
            this.totalRows = parseInt(res.data.total, 10)
            this.items = res.data.data

            let total = res.data.status_total
            let { statusList } = Dropdown

            for(let key in total) {
              let obj = total[key] || {}

              statusList = statusList.map( status => {
                if(this.formattedChar(status.text) == this.formattedChar(obj._id)) {
                  status.total = obj.total
                }

                return status
              })
            }

            this.$emit('fetchFilter', statusList)
            this.toggleBusy()
          })
        }
      },
      toggleBusy() {
        this.isBusy = !this.isBusy
      },
      openFormBar(row, editMode = false) {
        let { _id, candidate_id } = row
        this.id = _id
        this.candidate_id = candidate_id && typeof candidate_id == 'object' ? candidate_id._id : ''
        if(!editMode){
          this.$refs.side_bar.show()
        }
        else{
          this.isEditSidebarOpen = !this.isEditSidebarOpen
        }
      },
      closeFormBar(result){
        this.isSidebarOpen = result
        this.isEditSidebarOpen = result
      },
      changeStatus(id, add_interview_step) {
        this.$refs.status.show()
        this.id = id
        this.add_interview_step = add_interview_step
      },
      updateStatus(component){
        let { model, parameters } = component
        let { date, start_time, end_time, status, add_interview, rejected, assign_to, sub_status, assign_exam, meetingType, meetingLink } = model
        let { value } = status
        let subStatus = sub_status ? sub_status.value : ''
        assign_to = assign_to ? assign_to._id : assign_to
        assign_exam = assign_exam ? assign_exam._id : assign_exam

        if(!subStatus && value != 4) {
          let errorMessage = 'select a Substatus'
          this.$bvToast.toast(`Please ${errorMessage}`, {
            title: 'Error',
            variant: 'danger'
          })

          return false
        }
        console.log(model)
        let isInterview = (subStatus >= 4 && subStatus <= 10) ? true : false
        let isValid = date && start_time && end_time ? true : false

        if(!isValid && !!isInterview && !rejected) {
          this.$bvToast.toast(`Please select valid Date & Time`, {
            title: 'Error',
            variant: 'danger'
          })

          return false
        }

        model = {
          ...model,
          status: value,
          rejected: !!rejected,
          add_interview: !!add_interview,
          add_interview_step: add_interview ? this.add_interview_step + 1 : this.add_interview_step,
          assign_to,
          sub_status,
          assign_exam,
          meetingType,
          meetingLink,
        }
        
        let modelData = {id: parameters.applicationID, ...model}
        
        this.update(modelData).then(() => {
          this.$refs.status.hide()
          this.fetchData()
        }).catch((err) => {
          this.$bvToast.toast(err.response.data.errorMessage, {
            title: 'Error',
            variant: 'danger'
          })
        })
      },
      filterByStatus(status) {
        let statusList = Dropdown.statusList
        statusList = statusList.map( obj => {
          if(obj.value == status.value && obj.add_interview == status.add_interview) {
            obj.active = !obj.active
          } else {
            //deselect the previous selection
            obj.active = false
          }
          return { ...obj }
        })
        
        let value = statusList.filter(item => item.active).map(ele=>ele.value);
        let rejected = statusList.filter(item => item.active && item.value == 8);

        this.fetchData(this.type, false, value, rejected.length == 1)
      },
      formattedChar(val) {
        return val.toLowerCase().replace(' ', '-')
      },
      onFilter(val){
        this.filterItems = { ...val } || this.filterItems
        this.fetchData(this.type).catch(error => {
          console.error(error)
        })
      },
    },
    watch: {
      currentPage: {
        handler: function() {
          this.fetchData(this.type).catch(error => {
            console.error(error)
          })
        }
      },
      perPage: {
        handler: function() {
          this.fetchData(this.type).catch(error => {
            console.error(error)
          })
        }
      }
    }
  }
</script>

<style lang="scss">
  .modalBodyContainer {
    background: #e8eaee;
    overflow: auto;
    height: 80vh;
  }

  .custom-chip {
    display: inline-block;
    padding: 0 15px;
    height: 30px;
    line-height: 30px;
    border-radius: 25px;
    background-color: #E8E8E8;
    margin: 4px 0;
    border: #E8E8E8;
    font-weight: 600;
  }

  .chip-filter {
    border: 1px solid rgba(3, 0, 19, 0.24);
    background-color: rgb(255, 255, 255);
    color: rgba(1, 1, 1, 0.4);
    line-height: 0px;
    padding: 0 10px;
  }

  .chip-filter-active {
    border: none;
    background-color: rgba(1, 1, 1, 0.1);
    color: rgba(1, 1, 1, 0.75);
  }

  .chip-filter,
  .chip-filter-active {
    border-radius: 10px;
  }

  .chip-total {
    font-size: 10px;
    background: rgba(235, 47, 91, 0.2);
    border-radius: 3px;
    color: #B42244;
  }

  //shortlisted
  .chip-status1 {
    background-color: rgba(235, 47, 91, 0.16);
    color: #EB2F5B;
    .icon-dot {
      background: #EB2F5B;
    }
  }

  //submitted
  .chip-status2 {
    background-color: #E9D580;
    color: #89741B;
    .icon-dot {
      background: #89741B;
    }
  }

  //interviews
  // .chip-status5,
  // .chip-status3,
  .chip-status3 {
    background-color: #D7F8FF;
    color: #2BB7D6;
    .icon-dot {
      background: #2BB7D6;
    }
  }

  //offend
  .chip-status4 {
    background-color: #D3EEDB;
    color: #25522E;
    .icon-dot {
      background: #25522E;
    }
  }

  //placed
  .chip-status5 {
    background-color: #D4C4E2;
    color: #573B70;
    .icon-dot {
      background: #573B70;
    }
  }

  //rejected
  .chip-status8 {
    background-color: #FFA5A5;
    color: #800000;
    .icon-dot {
      background: #800000;
    }
  }

  .chip-substatus {
    background-color: rgba(205, 228, 251, 0.31);;
    color: #0256AA;
  }
</style>